const maintenanceTimelineContent = {
  created: 'Created Maintenance.',
  to: 'to',
  from: 'from ',
  empty_value_1: 'none',
  empty_value_2: 'none',
  change_identifier: 'Changed the identifier of',
  change_description: 'Changed the Description of',
  change_value: 'Changed the value of R$',
  change_company: 'Changed the Responsible Company from',
  change_send_to_maintenance_date: 'Changed the Expected Maintenance Shipment Date',
  change_return_from_maintenance_date: 'Changed the Expected Maintenance Return Date',
  change_warranty: 'Changed the Warranty Period',
  change_expiration: 'Changed the Expiry Date',
  file: 'The file',
  add_file: 'has been added.',
  delete_file: 'was deleted.',
  change: 'changed maintenance.',
};

export default maintenanceTimelineContent;